import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { Router, UrlTree } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';

export interface DialogData {
  message: string;
  references: Reference[];
}

export interface Reference {
  name: string;
  path: UrlTree | null;
}

@Component({
    selector: 'sentry-references-dialog',
    templateUrl: './references-dialog.component.html',
    standalone: true,
    imports: [MatDialogModule, CommonModule, MatButtonModule, MatListModule]
})
export class ReferencesDialogComponent {
  readonly message!: string;
  readonly references!: Reference[];
  readonly navigateToReference!: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private dialogRef: MatDialogRef<ReferencesDialogComponent>,
    private readonly router: Router
  ) {
    if (data) {
      this.message = data.message;
      this.references = data.references;
      this.navigateToReference = data.references.some((x) => x.path);
    }
  }

  referenceClick(url: UrlTree | null) {
    if (!url) {
      return;
    }
    this.router.navigateByUrl(url);
    this.dialogRef.close(true);
  }
}
